export const applyCPFMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, '')

  if (cleanValue.length > 11) {
    cleanValue = cleanValue.slice(0, 11)
  }

  cleanValue = cleanValue.replace(/(\d{3})(\d)/, '$1.$2')
  cleanValue = cleanValue.replace(/(\d{3})(\d)/, '$1.$2')
  cleanValue = cleanValue.replace(/(\d{3})(\d{1,2})$/, '$1-$2')

  return cleanValue
}

export const applyPhoneMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, '')

  if (cleanValue.length > 11) {
    cleanValue = cleanValue.slice(0, 11)
  }

  if (cleanValue.length > 10) {
    // Celular com 9º dígito: (XX) XXXXX-XXXX
    cleanValue = cleanValue.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3')
  } else if (cleanValue.length > 6) {
    // Fixo ou celular sem o 9º dígito: (XX) XXXX-XXXX
    cleanValue = cleanValue.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
  } else if (cleanValue.length > 2) {
    cleanValue = cleanValue.replace(/^(\d{2})(\d{0,4})/, '($1) $2')
  } else if (cleanValue.length > 0) {
    cleanValue = cleanValue.replace(/^(\d{0,2})/, '($1')
  }

  if (cleanValue.endsWith('-')) {
    cleanValue = cleanValue.slice(0, -1)
  }

  return cleanValue.trim()
}

export const applyCEPMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, '')

  if (cleanValue.length > 8) {
    cleanValue = cleanValue.slice(0, 8)
  }

  cleanValue = cleanValue.replace(/(\d{5})(\d)/, '$1-$2')

  return cleanValue
}


export const applyDateMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, '')

  if (cleanValue.length > 8) {
    cleanValue = cleanValue.slice(0, 8)
  }

  if (cleanValue.length > 4) {
    cleanValue = cleanValue.replace(/^(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3')
  } else if (cleanValue.length > 2) {
    cleanValue = cleanValue.replace(/^(\d{2})(\d{0,2})/, '$1/$2')
  }

  return cleanValue
}

export const applyCNPJMask = (value: string): string => {
  let cleanValue = value.replace(/\D/g, '')

  if (cleanValue.length > 14) {
    cleanValue = cleanValue.slice(0, 14)
  }

  cleanValue = cleanValue.replace(/^(\d{2})(\d)/, '$1.$2')
  cleanValue = cleanValue.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
  cleanValue = cleanValue.replace(/\.(\d{3})(\d)/, '.$1/$2')
  cleanValue = cleanValue.replace(/(\d{4})(\d{1,2})$/, '$1-$2')

  return cleanValue
}

export const applyDocumentMask = (value: string): string => {
  const digits = value.replace(/\D/g, '')
  return digits.length <= 11 ? applyCPFMask(value) : applyCNPJMask(value)
}
